<template>
    <div>
      <div v-if="loading">
        <Loading> </Loading>
      </div>
    <div v-if="!loading">
    <v-container fluid>
      <v-card-title>
        <h2 class="primary--text">Scheduled Bookings</h2>
        <v-spacer></v-spacer> <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search ..."
            single-line
            hide-details
          >
          </v-text-field> 
      </v-card-title>
      <br/>
      <v-data-table
        dense
        :headers="headers"
        :items="getScheduledBookings"
        :search="search"
        @click:row="handleEvent"
        class="elevation-1 data-row"
      >
      </v-data-table>
      <br/>
      <v-btn v-on:click="loadMore" :disabled="pageEnd" class="primary mr-10">Load More</v-btn>
    </v-container>
    </div>
    </div>
    </template>
    <script>
    import Loading from '@/components/Loading';    
    
    export default {
      name: 'ScheduledBookings',
     components: {
        Loading
      },
      data() {
        return {
          headers: [
            {
              text: 'Id',
              align: 'start',
              sortable: true,
              value: 'id',
              filterable: true,
            },
            { text: 'Booking Number', value: 'orderNumber' },
            { text: 'Date', value: 'date' },
            { text: 'Customer', value: 'customer' },
            { text: 'Company', value: 'company' },
            { text: 'Address', value: 'address' },
            { text: 'Waste', value: 'wasteName' },
            { text: 'Vehicle', value: 'vehicleName' },
            { text: 'Driver', value: 'driverName' },
            { text: 'Type', value: 'type' },
            { text: 'Status', value: 'status' },
            { text: 'Charge (ZAR)', value: 'cost' }
          ],
          bookingData: [],
          search: '',
          pageEnd: false
        }
      },
      watch: {
        getScheduledBookings(bookings){
          if (bookings.length < 1) {
            alert('There are no scheduled bookings yet');
          } 
          if(bookings.length < 500){
            this.pageEnd = true;
          }
        }
      },
      computed: {
        loading(){
          return this.$store.getters['admin/getLoading'];
        },
        getScheduledBookings(){
          return this.$store.getters['admin/getScheduledBookings'];
        },
        query(){
          return this.$store.getters['admin/getChargesQuery'];
        }
      },
      methods: {
        loadMore(){
          this.$store.dispatch('admin/fetchCharges', {bookingQuery: this.query, isLoadMore: true});
        },
        handleEvent(value){
          switch(value.type){
            case 'DELIVERY':
              this.$router.push('/dashboard/deliveryBookings');
              break;
            case 'EXCHANGE':
              this.$router.push('/dashboard/exchangeBookings')
              break;
            case 'COLLECTION': 
              this.$router.push('/dashboard/collectionBookings') 
              break;
            case 'LOAD':
              this.$router.push('/dashboard/truckBookings')
              break;
            default:
              break;
          }
        }
      },
      mounted() {
        if(this.$store.state.admin.charges.length === 0){
          this.$store.dispatch('admin/fetchCharges', {bookingQuery: this.query, isLoadMore: false});
        }
      }
    }
    </script>
    
    <style scoped>
    .data-row{
      cursor: pointer;
    }
    </style>